export const chamfrOutOfStockMiddleware = ({
  instantSearchInstance: search,
}) => {
  return {
    onStateChange() {},
    subscribe() {
      search._chamfrOOSXHR = new XMLHttpRequest();
      search._chamfrOOSTimer = null;
      search._chamfrOOSInFlightKey = "";

      attachBackInStockRedirectHandler();

      search.on("render", () => {
        const buttons = document.querySelectorAll(".back-in-stock-btn");
        const allProducts = [
          ...new Set([...buttons].map((btn) => btn.dataset.product || "0")),
        ].filter((id) => id && id !== "0");

        if (allProducts.length === 0) return;

        // Check cache
        const cache = JSON.parse(
          sessionStorage.getItem("chamfrOOSCache") || "{}"
        );
        const cachedProductIds = Object.keys(cache);
        const uncachedProducts = allProducts.filter(
          (id) => !cachedProductIds.includes(id)
        );
        const requestKey = [...uncachedProducts].sort().join(",");

        // Apply cached data immediately
        allProducts.forEach((id) => {
          if (!cachedProductIds.includes(id)) return;

          applyBackInStockData(cache[id]);
        });

        // Nothing new to fetch
        if (uncachedProducts.length === 0) return;

        if (requestKey === search._chamfrOOSInFlightKey) {
          return;
        }

        window.clearTimeout(search._chamfrOOSTimer);
        search._chamfrOOSTimer = window.setTimeout(() => {
          // Abort old request
          const xhrStatus = search._chamfrOOSXHR.readyState || 0;
          if (xhrStatus && xhrStatus !== 4) {
            search._chamfrOOSXHR.abort();
          }

          // New AJAX request
          const xhr = new XMLHttpRequest();
          search._chamfrOOSXHR = xhr;
          search._chamfrOOSInFlightKey = requestKey;

          xhr.open("POST", getChamfrAjaxUrl());
          xhr.setRequestHeader(
            "Content-Type",
            "application/x-www-form-urlencoded"
          );

          xhr.onload = function () {
            search._chamfrOOSInFlightKey = "";

            if (xhr.status === 200) {
              try {
                const response = JSON.parse(xhr.responseText);
                const updatedCache = {
                  ...JSON.parse(
                    sessionStorage.getItem("chamfrOOSCache") || "{}"
                  ),
                };

                response.forEach((el) => {
                  updatedCache[el.product_id] = el;
                  applyBackInStockData(el);
                });

                // Save updated cache
                sessionStorage.setItem(
                  "chamfrOOSCache",
                  JSON.stringify(updatedCache)
                );
              } catch (e) {
                console.error("Invalid response:", e);
              }
            }
          };

          xhr.onerror = function () {
            search._chamfrOOSInFlightKey = "";
          };

          xhr.onabort = function () {
            if (search._chamfrOOSXHR === xhr) {
              search._chamfrOOSInFlightKey = "";
            }
          };

          xhr.send(
            "action=out_of_stock_area&stringify=1&products_ids=" +
              encodeURIComponent(JSON.stringify(uncachedProducts))
          );
        }, 100);
      });
    },
    unsubscribe() {},
  };
};

function getChamfrAjaxUrl() {
  return (
    (window.algolia && window.algolia.ajax_url) ||
    (window.CHAMFR && window.CHAMFR.ajaxUrl) ||
    window.ajaxurl ||
    "/wp-admin/admin-ajax.php"
  );
}

function attachBackInStockRedirectHandler() {
  if (document.body.dataset.chamfrBisRedirectHandler === "1") {
    return;
  }

  document.body.dataset.chamfrBisRedirectHandler = "1";
  document.body.addEventListener("click", (event) => {
    const button = event.target.closest(
      ".js_wc_bis_loop_signup_prompt_trigger_redirect"
    );

    if (!button) {
      return;
    }

    const redirectTo = button.dataset.bisLoopRedirectTo;

    if (!redirectTo) {
      return;
    }

    event.preventDefault();

    const oldForm = document.getElementById("wc_bis_loop_signup_live_form");
    if (oldForm) {
      oldForm.remove();
    }

    const form = document.createElement("form");
    const field = document.createElement("input");

    form.method = "post";
    form.id = "wc_bis_loop_signup_live_form";
    form.action = redirectTo;
    form.style.display = "none";

    field.type = "hidden";
    field.name = "wc_bis_loop_signup_prompt_posted";
    field.value = "1";

    form.appendChild(field);
    document.body.appendChild(form);
    form.submit();
  });
}

function applyBackInStockData(el) {
  const button = document.getElementById(`back-in-stock-${el.product_id}`);
  if (!button) return;

  const redirectHTML = document.createElement("div");
  redirectHTML.innerHTML = el.html;

  const redirectEl = redirectHTML.querySelector(
    ".js_wc_bis_loop_signup_prompt_trigger_redirect"
  );

  if (!redirectEl) return;

  const redirectURL = redirectEl.dataset.bisLoopRedirectTo;

  button.classList.remove("btn-disabled");
  button.classList.add("js_wc_bis_loop_signup_prompt_trigger_redirect");
  button.dataset.bisLoopRedirectTo = redirectURL;
}
